import React from "react";
import {
  FaShieldAlt,
  FaChargingStation,
  FaSwimmingPool,
  FaDumbbell,
  FaParking,
  FaChild,
  FaMosque,
  FaVideo,
} from "react-icons/fa";
import "./Amenities.css";

const amenitiesList = [
  { icon: <FaShieldAlt />, title: "24/7 Security Guard" },
  { icon: <FaChargingStation />, title: "Generator Backup" },
  { icon: <FaSwimmingPool />, title: "Rooftop Swimming Pool" },
  { icon: <FaDumbbell />, title: "Modern Fitness Gym" },
  { icon: <FaParking />, title: "Spacious Car Parking" },
  { icon: <FaChild />, title: "Kids Play Area" },
  { icon: <FaMosque />, title: "Prayer Hall / Mosque" },
  { icon: <FaVideo />, title: "CCTV Surveillance" },
];

const Amenities = () => {
  return (
    <div style={{ background: "#ffffffff" }}>
      <section className="amenities-section">
        <div className="custom-container">
          <div style={{ textAlign: "center" }}>
            <h2>
              KEY <span className="styleTitle">AMENITIES & FEATURES</span>
            </h2>
            <p className="subtitle">
              Experience luxury, security, and convenience with top-notch modern
              facilities
            </p>
          </div>

          <div className="amenities-grid">
            {amenitiesList.map((item, index) => (
              <div key={index} className="amenity-card">
                <div className="amenity-icon">{item.icon}</div>
                <h4>{item.title}</h4>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Amenities;
